const testIdPrefix = 'Student-profile'

export const testIDs = {
  familyNotes: `${testIdPrefix}-family-notes`,
  studentNotes: `${testIdPrefix}-student-notes`,
}
